import { LIMPAR_TRECHOS } from '../types'

export default function limparTrechos () {
  return {
    type: LIMPAR_TRECHOS,
  }
}
